import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function CashAndCashiers() {
  return (
    <Box sx={{ flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10 }}>
        <Typography sx={{ fontSize: 24, marginTop: 6 }} color="pimary" gutterBottom>
            Кассиры и кассовые аппараты:
        </Typography>
    </Box>
    
  )
}
